import { useEffect, useRef } from "react";

export function useTouchHandler() {
  const touchStart = useRef({ x: 0, y: 0 });
  const touchMove = useRef({ x: 0, y: 0 });
  const isHorizontalSwipe = useRef(false);
  /** Only lock scroll for horizontal swipes that began on a card photo carousel (not filter chips, etc.). */
  const swipeCarouselRoot = useRef(null);

  useEffect(() => {
    const handleTouchStart = (e) => {
      const touch = e.touches[0];
      touchStart.current = { x: touch.clientX, y: touch.clientY };
      isHorizontalSwipe.current = false;
      const el = e.target;
      swipeCarouselRoot.current =
        el && typeof el.closest === "function"
          ? el.closest(".card-carousel-root")
          : null;
    };

    const handleTouchMove = (e) => {
      if (!swipeCarouselRoot.current) return;

      const touch = e.touches[0];
      touchMove.current = { x: touch.clientX, y: touch.clientY };

      const dx = touchMove.current.x - touchStart.current.x;
      const dy = touchMove.current.y - touchStart.current.y;

      // If we haven't determined the swipe direction yet
      if (!isHorizontalSwipe.current) {
        // Determine if this is a horizontal swipe (if horizontal movement is greater than vertical)
        isHorizontalSwipe.current = Math.abs(dx) > Math.abs(dy);
      }

      // If it's a horizontal swipe, prevent vertical scrolling
      if (isHorizontalSwipe.current) {
        e.preventDefault();
      }
    };

    const handleTouchEnd = () => {
      isHorizontalSwipe.current = false;
      swipeCarouselRoot.current = null;
    };

    // Add event listeners to the document to catch all touch events
    document.addEventListener("touchstart", handleTouchStart, {
      passive: false,
    });
    document.addEventListener("touchmove", handleTouchMove, { passive: false });
    document.addEventListener("touchend", handleTouchEnd);

    // Cleanup
    return () => {
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchend", handleTouchEnd);
    };
  }, []);
}
